import { Component, OnInit, Injector } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertsService } from 'src/modules/base/services/alerts.service';
import { StorageService } from 'src/modules/base/shared/services/storage.service';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AppService } from 'src/modules/base/shared/services/app.service';

@Component({
    selector: 'kx-change-password',
    templateUrl: './change-password.component.html',
    styleUrls: ['./change-password.component.scss'],
    standalone: false
})
export class ChangePasswordComponent {
  public _resourceDef: any;
  public _currentResource: string = '';
  // formBlocks: any = [];
  activatedResource: string;
  showflatform: boolean = false;
  // objData: { formblocks: any; data: any; activatedResource: string; };
  currentFields: any = {};
  id: any;
  user: any = {
    currentUser: ''
  }
  userData: any = {

  };
  config: any;
  action: string;
  constructor(
    // public injector: Injector,
    private appService: AppService,
    public route: ActivatedRoute,
    private router: Router,
    private alertService: AlertsService,
    private storageService: StorageService,
    private baseService: BaseService,
    private authService: AuthenticationService
  ) {
    // super(injector, route);
  }
  ngOnInit() {
    this.config = {
      "submitButton" : true,
      "cancelButton" : true,
      "filterForm" : false,
      "clearOnSave": true,
      "delegateSave": true,
      "cancelRoute": ''
    }
    this.action = 'MODIFY';
    // this.getResource();
    this.getUserData();
  }
  getResource() {
    this.baseService.init(this._currentResource);
    this.baseService.getResourceDef(this._currentResource, (resourceDef) => {
      if (resourceDef) {
        console.log('resource defination -------------->', resourceDef);

        this._resourceDef = resourceDef;
        this.baseService.getReferredField(resourceDef.form, (response) => {
          this.currentFields['blocks'] = response;
          this.currentFields['submitButton'] = true;
        });
      }
    })
  }


  onSaveFinished(event) {
    console.log('event after updating...................', event);
    let result = event.result;
    result['confirm_password'] = this.appService.encryptData(result['confirm_password']);
    result['old_password'] = this.appService.encryptData(result['old_password']);
    result['password'] = this.appService.encryptData(result['password']);
    this.baseService.action(result, '', 'account-management', this._currentResource).subscribe(res => {
      console.log('after data post ==>>', res);
      if (res.errCode == -1) {
        this.alertService.error(res.message);
      } else if (res.errCode == 0) {
        //this.storageService.setData()
        /************* not needed  **********/
        var currentUser = this.authService.getCurrentUser();
        currentUser.isPasswordExpired = false;
       // currentUser.session_id = this.authService.getSessionId();
        this.authService.setUser(currentUser);
        this.storageService.setData('currentUser', currentUser, () => {
          console.log('current user data changed');
        });
        /************* not needed  **********/
        this.alertService.successWithMessage('Password Changed!', "Please login again with new credentials.");
        setTimeout(() =>{
          this.baseService.logout();
        },1000);//set timeout so that user can read the message.
        
        //this.router.navigate([this.appService._currentSessionData.dashboardUrlFound]);
      }
    });
  }

  getUserData() {
    // this.storageService.getData('currentUser', (userId) => {
    //   this.id = userId.id;
    // })
    this.user.currentUser = this.authService.getCurrentUser();
    console.log('current user', this.user.currentUser);
   // this.userData.session_id = this.user.currentUser.session_id;
    this._currentResource = "change_password";
    this.getResource();

  }

  cancelButtonClick() {
    this.router.navigate([this.appService._currentSessionData.dashboardUrlFound]);
  }
}
